import { useEffect } from "react";

export default function useIOSKeyboardScrollReset() {
  useEffect(() => {
    const isTouch =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(pointer: coarse)").matches;
    if (!isTouch) return;

    const isField = (el) =>
      !!el &&
      (el.tagName === "INPUT" ||
        el.tagName === "TEXTAREA" ||
        el.isContentEditable);

    const resetIfIdle = () => {
      if (isField(document.activeElement)) return;
      const se = document.scrollingElement || document.documentElement;
      if (window.scrollY !== 0 || (se && se.scrollTop !== 0)) {
        window.scrollTo(0, 0);
        if (se) se.scrollTop = 0;
      }
    };

    let timer;
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        resetIfIdle();
        setTimeout(resetIfIdle, 300);
      }, 150);
    };

    const onFocusOut = (e) => {
      if (isField(e.target)) schedule();
    };

    document.addEventListener("focusout", onFocusOut);
    window.addEventListener("orientationchange", schedule);
    window.visualViewport?.addEventListener("resize", schedule);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("focusout", onFocusOut);
      window.removeEventListener("orientationchange", schedule);
      window.visualViewport?.removeEventListener("resize", schedule);
    };
  }, []);
}
